import { render, staticRenderFns } from "./ColumnRecruitmentList.vue?vue&type=template&id=6d0850e4&scoped=true"
import script from "./ColumnRecruitmentList.vue?vue&type=script&lang=js"
export * from "./ColumnRecruitmentList.vue?vue&type=script&lang=js"
import style0 from "./ColumnRecruitmentList.vue?vue&type=style&index=0&id=6d0850e4&prod&lang=scss&scoped=true"
import style1 from "./ColumnRecruitmentList.vue?vue&type=style&index=1&id=6d0850e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0850e4",
  null
  
)

export default component.exports